import DataGrid2 from '../..';

export function calculateHeight(this: DataGrid2) {
	if (this.displayType == 'AutoFill' && this.__form.windowSize.height) {
		let height = this.__form.windowSize.height - 10;

		if (this.__form.toolbarButtons.some(t => t.enabled)) {
			height = height - 75;
		}

		return height;
	}

	if (this.displayType == 'MaxHeight' || this.virtualScrolling) {
		return this.height || 450;
	}
}
